/** Gedeelde form field classes voor superadmin formulieren. */
export const SA_FIELD_LABEL_CLASS =
  'block text-xs font-medium text-sa-foreground'

export const SA_FIELD_INPUT_CLASS =
  'mt-1 w-full rounded-sa-md border border-sa-border bg-sa-surface px-3 py-2 text-sm text-sa-foreground sa-focus-ring'

export const SA_FIELD_HINT_CLASS =
  'mt-1 text-[11px] text-sa-muted-foreground'

export const SA_FIELD_MONO_BOX_CLASS =
  'mt-2 break-all rounded-sa-md bg-sa-surface-sunken px-2 py-1.5 font-mono text-[11px] text-sa-foreground'
